import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UserService, OperationsService, AuthenticationService, StorageService } from '../../_services/index';
import { FormArray, ReactiveFormsModule, FormsModule, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-customerwalletsgl',
  templateUrl: './customerwalletsgl.component.html',
  styleUrls: ['./customerwalletsgl.component.css']
})
export class CustomerwalletsglComponent implements OnInit {
  currentUser:any;
  @Input('account') account:any;
  @Input('account_details') account_details: any;
  @Input('ledger') ledger: any;
  @Input('from_wallet') from_wallet: any = false;
  @Input('transactions') transactions: any;
  @Input('overlayOpen') overlayOpen: boolean;
  showNoRightOverlay: boolean = false;
  @Output() dateChanged = new EventEmitter();
  ledgers: any;
  loading = false; 
  FISCAL_DATE_START = '';
  FISCAL_DATE_END = '';
  TTYPE='0';
  LENDER_ACCOUNT_ID = '';
  exportable = false;
  people_customers:any;
  PEOPLE_CUSTOMER:any;
  constructor(public fb: FormBuilder, public operationsService: OperationsService, public storageService: StorageService, private authService: AuthenticationService) {
    this.currentUser = this.storageService.read<any>('currentUser');

  }

  ngOnInit() {
    this.getStatement(); 
  }
  grantRight(right) {
    return this.authService.userHasRights(right);
  } 
  exportRecords() {
    if (!this.grantRight('72')) {
      this.overlayOpen = false;
      this.showNoRightOverlay = true;
    } else {
      this.loading = true;
      this.exportable = false;
      // Send to the server
      this.operationsService.exportRecords(this.currentUser.token, this.account_details, this.FISCAL_DATE_START, this.FISCAL_DATE_END,this.ledgers.contra_charts).subscribe(data => {
        this.loading = false;
        if (data.status) {
          alert('Data Successfully exported. Download would start automatically.');
          window.open(data.message);
          return;
        } else {
          this.exportable = true;
          alert('Data could not be exported.');
        }
      }, () => this.exportable = true);
    }

  }
  getStatement() {
    this.loading = true;
    this.exportable = false;
    this.operationsService.getCustomerWalletsGL(this.currentUser.token, this.FISCAL_DATE_START, this.FISCAL_DATE_END)
      .subscribe(data => {
        this.loading = false;
        this.ledgers = data;
        this.exportable = true;
      });
  }
  filterRecords() {
    if (!this.grantRight('73')) {
      this.overlayOpen = false;
      this.showNoRightOverlay = true;
    } else {
      this.getStatement();
    }
  }

}
